export class CarouselModel {
    id: number;
    imageSrc: string;
    route: string;
    createdAt: string;
    updatedAt: string;
    ord: number;
    file: File;
}
